import { render } from "./cell_list1.vue?vue&type=template&id=15f26c02"
import script from "./cell_list1.vue?vue&type=script&lang=ts"
export * from "./cell_list1.vue?vue&type=script&lang=ts"
script.render = render

export default script